import { ISaveUserRequest } from "common/interfaces/apiRequest/ISaveUserRequest";
import { IUpdateUserRequest } from "common/interfaces/apiRequest/IUpdateUserRequest";
import { TemplateRestService } from "infrastructure/rest/TemplateRestService";

const USER_BASE = "/User";
const secureUserRestService = new TemplateRestService(true, USER_BASE);

export class UserApi {

    public static async getAdUsers(searchPattern: string): Promise<any> {
        const response = await secureUserRestService.get(`/adusers/${searchPattern}`);
        return response.data;
    }

    public static async getCurrentUser(): Promise<any> {
        const response = await secureUserRestService.get(`/currentuser`);
        return response.data;
    }
    
    public static async getUsers(): Promise<any> {
        const response = await secureUserRestService.get("");
        return response.data;
    }
    public static async saveUser(saveUserRequest: ISaveUserRequest): Promise<any> {
        const response = await secureUserRestService.post("", { user: saveUserRequest });
        return response.data;
    }

    public static async updateUser(updateUserRequest: IUpdateUserRequest): Promise<any> {
        const response = await secureUserRestService.put("", { user: updateUserRequest });
        return response.data;
    }

    public static async getUserById(id: number): Promise<any> {
        const response = await secureUserRestService.get(`/${id}`);
        return response.data;
    }

    public static async getUserAuditById(id: number): Promise<any> {
        const response = await secureUserRestService.get(`/audit/${id}`);
        return response.data;
    }
}
